import { useState } from "react";
import html2canvas from "html2canvas";

export const useTagDownloader = () => {
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownloadTag = async (tag) => {
    if (!tag || !tag.images?.length || isDownloading) return;

    setIsDownloading(true);

    const labels = [
      "TOP VIEW",
      "SIDE VIEW (0°)",
      "SIDE VIEW (180°)",
    ];

    const container = document.createElement("div");

    // CONFIGURATION
    const EXPORT_IMAGE_WIDTH = "300px";
    const EXPORT_IMAGE_HEIGHT = "";
    const EXPORT_LABEL_HEIGHT = "35px";
    const EXPORT_LABEL_FONT_SIZE = "14px";

    try {
      const imageSources = await Promise.all(
        tag.images.map(async (image) => {
          try {
            const res = await fetch(image.url);
            const blob = await res.blob();

            return {
              ...image,
              src: URL.createObjectURL(blob),
            };
          } catch {
            const proxyUrl = `https://wsrv.nl/?url=${encodeURIComponent(
              image.url
            )}`;

            const res = await fetch(proxyUrl);
            const blob = await res.blob();

            return {
              ...image,
              src: URL.createObjectURL(blob),
            };
          }
        })
      );

      // Main Outer Container
      container.style.position = "fixed";
      container.style.left = "-10000px";
      container.style.top = "0";
      container.style.display = "flex";
      container.style.flexDirection = "column";
      container.style.alignItems = "center";
      container.style.padding = "30px";
      container.style.background = "#ffffff";
      container.style.width = "max-content";

      // HEADER
      const titleHeader = document.createElement("div");

      titleHeader.innerText = tag.name
        .toLowerCase()
        .startsWith("tag")
        ? tag.name
        : `Tag — ${tag.name}`;

      titleHeader.style.fontSize = "22px";
      titleHeader.style.fontWeight = "800";
      titleHeader.style.color = "#000000";
      titleHeader.style.marginBottom = "20px";
      titleHeader.style.fontFamily = "sans-serif";

      container.appendChild(titleHeader);

      // IMAGES ROW
      const imagesRow = document.createElement("div");

      imagesRow.style.display = "flex";
      imagesRow.style.gap = "15px";

      imageSources.forEach((image, idx) => {
        const card = document.createElement("div");

        card.style.border = "1.5px solid #222222";
        card.style.background = "#fff";
        card.style.display = "flex";
        card.style.flexDirection = "column";
        card.style.alignItems = "center";
        card.style.width = EXPORT_IMAGE_WIDTH;

        // IMAGE WRAPPER
        const imgWrapper = document.createElement("div");

        imgWrapper.style.width = "100%";
        imgWrapper.style.height = EXPORT_IMAGE_HEIGHT;
        imgWrapper.style.display = "flex";
        imgWrapper.style.justifyContent = "center";
        imgWrapper.style.alignItems = "center";
        imgWrapper.style.overflow = "hidden";

        const img = document.createElement("img");

        img.src = image.src;

        img.style.width = "100%";
        img.style.height = "100%";
        img.style.objectFit = "cover";

        // IMAGE LABEL
        const label = document.createElement("div");

        label.innerText =
          labels[idx] || `IMAGE ${idx + 1}`;

        label.style.width = "100%";
        label.style.height = EXPORT_LABEL_HEIGHT;
        label.style.background = "#1a1a1a";
        label.style.color = "#ffffff";
        label.style.fontSize = EXPORT_LABEL_FONT_SIZE;
        label.style.fontWeight = "bold";
        label.style.letterSpacing = "0.5px";
        label.style.display = "flex";
        label.style.justifyContent = "center";
        label.style.alignItems = "center";
        label.style.fontFamily = "sans-serif";

        imgWrapper.appendChild(img);

        card.appendChild(imgWrapper);

        card.appendChild(label);

        // LOCATION CONTAINER
        // const locationContainer = document.createElement("div");

        // locationContainer.style.width = "100%";
        // locationContainer.style.padding = "10px";
        // locationContainer.style.boxSizing = "border-box";
        // locationContainer.style.background = "#f7f7f7";
        // locationContainer.style.fontFamily = "sans-serif";

        // // LATITUDE
        // const latitude = document.createElement("div");

        // latitude.innerText = `Latitude: ${
        //   image.latitude ?? "N/A"
        // }`;

        // latitude.style.fontSize = "12px";
        // latitude.style.fontWeight = "600";
        // latitude.style.color = "#333333";
        // latitude.style.marginBottom = "4px";

        // // LONGITUDE
        // const longitude = document.createElement("div");

        // longitude.innerText = `Longitude: ${
        //   image.longitude ?? "N/A"
        // }`;

        // longitude.style.fontSize = "12px";
        // longitude.style.fontWeight = "600";
        // longitude.style.color = "#333333";

        // locationContainer.appendChild(latitude);
        // locationContainer.appendChild(longitude);

        // card.appendChild(locationContainer);

        imagesRow.appendChild(card);
      });

      container.appendChild(imagesRow);

      document.body.appendChild(container);

      // Wait for images to load
      const images = container.querySelectorAll("img");

      await Promise.all(
        Array.from(images).map(
          (img) =>
            new Promise((resolve) => {
              if (img.complete) {
                resolve();
              } else {
                img.onload = resolve;
                img.onerror = resolve;
              }
            })
        )
      );

      // Render Canvas
      const canvas = await html2canvas(container, {
        useCORS: true,
        scale: 2,
        backgroundColor: "#ffffff",
      });

      const link = document.createElement("a");

      link.download = `${tag.name.replace(
        /\s+/g,
        "_"
      )}_combined.png`;

      link.href = canvas.toDataURL("image/png");

      link.click();

      // Cleanup object URLs
      imageSources.forEach((image) => {
        if (image.src) {
          URL.revokeObjectURL(image.src);
        }
      });
    } catch (error) {
      console.error("Export failed:", error);
    } finally {
      if (document.body.contains(container)) {
        document.body.removeChild(container);
      }

      setIsDownloading(false);
    }
  };

  return {
    handleDownloadTag,
    isDownloading,
  };
};